<template>
    <div class="rangeslider">
      <div class="slider__container">
        <div class="slider__minval">
          <slot name="minval"></slot>
        </div>
        <div class="slider__maxval">
          <slot name="maxval"></slot>
        </div>
      </div>
      <input type="range" min="0" class="slider" id="myRange"
        :max="maxVal"
        :step="step" 
        v-model="update"
        v-bind:style="{background: 'linear-gradient(to right, red 0%, red ' + progress + '%, #d3d3d3 ' + progress + '%, #d3d3d3 100%)'}">
    </div>
</template>


<script>
import { numberMixin } from '../mixins/numberMixin'
export default {
  mixins: [numberMixin],
  props: ['minVal', 'maxVal', 'val', 'dynamic', 'step'],
  data: function () {
    return {
      getter: 'get' + this.dynamic, //Create the getter-string
      setter: 'update' + this.dynamic, //Create the setter-string
    }
  },
  computed: {
    update: {
      get () {
        return this.$store.getters[this.getter]
      }, 
      set (value) {
        this.$store.commit(this.setter, value)
      }
    },
    progress: function () {
      return (this.val / this.maxVal)*100
    },
    formatMaxVal () {
      return this.formatNumber(this.maxVal)
    }
  },
}
</script>


<style>
.rangeslider {
  position: relative;
}
.slider { 
  -webkit-appearance: none;
  width: 100%;
  height: 12px;
  border-radius: 5px;  
  background: linear-gradient(to right, #d3d3d3 0%, #d3d3d3 100%);
  outline: none;
} 

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 28px;
  height: 28px;
  border-radius: 50%; 
  background: #fff;
  border: solid 1px grey;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fff;
  border: solid 1px grey;
  cursor: pointer;
}

.slider__container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px
}
</style>